<div class="create-dialog-box scrollable-dialog container">
    <div class="title d-flex align-items-center justify-content-space-between">
        <!-- <h4 class="mb-0">User List</h4> -->
        <div class="col-lg-3 col-md-3 col-sm-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label class="form-label">Select Job Role</mat-label>
                <mat-select
                    [(ngModel)]="selectedJobRole"
                    (selectionChange)="loadData()"
                >
                    <mat-option>
                        <ngx-mat-select-search
                            [formControl]="jobFilterCtrl"
                            placeholderLabel="Find name..."
                            noEntriesFoundLabel="No matching name found"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="">All</mat-option>
                    <mat-option
                        *ngFor="let data of filteredTenant | async"
                        [value]="data?.id"
                    >
                        {{ data?.name }}
                    </mat-option>
                </mat-select>
                <button *ngIf="selectedJobRole"  mat-icon-button
                    class="clear-icon" (click)="$event.stopPropagation();
                    clearSelection('jobFilterCtrl')"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label class="form-label">University Name</mat-label>
                <mat-select
                    [(ngModel)]="selectedUniversityName"
                    (selectionChange)="loadData()"
                >
                    <mat-option>
                        <ngx-mat-select-search
                            [formControl]="uniFilterCtrl"
                            placeholderLabel="Find name..."
                            noEntriesFoundLabel="No matching name found"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="">All</mat-option>
                    <mat-option
                        *ngFor="let role of universityFilter | async"
                        [value]="role.id"
                    >
                        {{ role.name }}
                    </mat-option>
                </mat-select>
                <button *ngIf="selectedUniversityName"
                            mat-icon-button
                            class="clear-icon"
                            (click)="
                                $event.stopPropagation();
                                clearSelection('uniFilterCtrl')
                            "
                        >
                            <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-5">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label class="form-label">User Name</mat-label>
                <input
                    matInput
                    class="form-control"
                    [formControl]="searchControl"
                    [(ngModel)]="searchText"
                    placeholder="Search by name..."
                    
                />
                        <button
                            *ngIf="
                                searchControl.value
                            "
                            mat-icon-button
                            class="clear-icon"
                            (click)="
                                $event.stopPropagation();
                                clearSelection('searchControl')
                            "
                        >
                            <mat-icon>close</mat-icon>
                        </button>
            </mat-form-field>
            
        </div>
        <button mat-icon-button type="button" class="cz-refresh-btn mb-12">
            <i class="ri-restart-line"></i>
        </button>
        <button
            class="close-btn bg-transparent p-0 border-none mb-12"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
        
    </div>

    <div class="table-container" appInfiniteScroll
        [scrollThreshold]="10"
        (scrolled)="onScroll()">      
        <!-- <cdk-virtual-scroll-viewport
            itemSize="80"
            class="example-viewport"
            appendOnly
        > -->
            <table
                mat-table
                [dataSource]="dataSource"
                class="application-history"
            >
                <!-- CAMS ID Column -->
                <ng-container matColumnDef="slNo">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="text-start no-whitespace"
                        width="15%"
                    >
                        Picture
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="fw-semibold text-center hover-text"
                    >
                        <p class="hover-id">
                            <img
                                *ngIf="element?.image; else defaultImage"
                                src="{{
                                    file_path_with_base_url(element?.image)
                                }}"
                                class="img-fluid rounded-circle profile-pic_zoom"
                                data-bs-toggle="tooltip"
                                data-placement="bottom"
                                data-bs-original-title=""
                                title="{{ element?.fullName }}"
                            />
                            <ng-template #defaultImage>
                                <img
                                    src="assets/img/company-logo/favicon_crizac_lgo.png"
                                    class="img-fluid rounded-circle profile-pic_zoom"
                                    data-bs-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Default Profile Picture"
                                />
                            </ng-template>
                        </p>
                    </td>
                </ng-container>
                <ng-container matColumnDef="fromdate">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="text-start no-whitespace"
                        width="25%"
                    >
                        User Name
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="fw-semibold text-start hover-text"
                    >
                        <p class="">
                            {{ element?.fullName }}
                            <span *ngIf="element?.gender"
                                >({{ element.gender }})</span
                            >
                        </p>
                        <span class="text-success"
                            >Status : {{ element?.loginStatus }} </span
                        ><br />
                        <span class="text-danger"
                            >Home Access : {{ element?.homeAccess }}
                        </span>
                        <br />
                        <span>USER NAME : {{ element.username }}</span
                        ><br />
                        <!-- <span>USER ID : {{ element?.userId }}</span> -->
                    </td>
                </ng-container>
                <ng-container matColumnDef="todate">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="text-start no-whitespace"
                    >
                        User Details / University Name
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="fw-semibold text-start hover-text"
                    >
                        <span class="hover-id">
                            <span class="text-success">User Group: </span>
                            {{ element?.userGroupName || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success">Supervisor: </span>
                            {{ element?.supervisor || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success"
                                >Supervisor Number:
                            </span>
                            {{ element?.supervisorNumber || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success">Employee Cabin: </span>
                            {{ element?.empCabin || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success"
                                >Employee Seat No.:
                            </span>
                            {{ element?.empSeat || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success">Job Role: </span>
                            {{ element?.jobRole || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success"
                                >Employee Designation:
                            </span>
                            {{ element?.empDesgination || "NA" }} </span
                        ><br />
                        <span class="hover-id">
                            <span class="text-success"
                                >Employee Department:
                            </span>
                            {{ element?.jobDetails || "NA" }}
                        </span>
                        <!-- <span>University :{{ element?.universityName }}</span> -->
                        <!-- <ul *ngIf="element?.universityName">
                            <li
                                *ngFor="
                                    let university of element?.universityName?.split(
                                        ', '
                                    )
                                "
                            >
                                {{ university }}
                            </li>
                        </ul> -->
                        <ul *ngIf="element?.universityWithJRMAndURM?.length">
                            <li *ngFor="let uni of element?.universityWithJRMAndURM" class="university-item">
                              <!-- University Name -->
                              <div class="university-name">
                                <strong>{{ uni.name }}</strong>
                              </div>
                          
                              <!-- JRM Section -->
                              <div *ngIf="uni.JRM" class="university-detail jrm-detail">
                                <span class="text-success">SRM: </span>
                                {{ uni.JRM }}
                              </div>
                          
                              <!-- URM Section -->
                              <div *ngIf="uni.URM" class="university-detail urm-detail">
                                <span class="text-success">URM: </span>
                                {{ uni.URM }}
                              </div>
                              <!-- Tenant Name -->
                              <div class="university-detail urm-detail">
                                <span class="text-success">Tenant: </span>
                                <strong>{{ uni.tenant }}</strong>
                              </div>
                            </li>
                          </ul>
                          

                        <!-- <span class="hover-id">
                            <span class="text-success"
                                >JRM:
                            </span>
                            <ol *ngIf="element?.JRM">
                                <li
                                    *ngFor="
                                        let university of element?.JRM?.split(
                                            ', '
                                        )
                                    "
                                >
                                {{ university }}
                                </li>
                            </ol>
                         </span>
                        <br>
                        <span class="hover-id">
                            <span class="text-success"
                                >URM:
                            </span>
                            <ul *ngIf="element?.URM">
                                <li
                                    *ngFor="
                                        let university of element?.URM?.split(
                                            ', '
                                        )
                                    "
                                >
                                    {{ university }}
                                </li>
                            </ul>
                             </span
                        > -->
                    </td>
                </ng-container>
                <ng-container matColumnDef="days">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="text-start no-whitespace"
                    >
                        Mobile / Land Line / Extension / Email
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="fw-semibold text-start hover-text text-center custom-width"
                    >
                        <span
                            class="hover-id extension"
                            [matTooltip]="'Call Mobile Number'"
                            (click)="outboundCall(element.mobileNumber)"
                        >
                            <i class="ri-smartphone-line"></i>

                            {{ element.mobileNumber }}
                            <span [matTooltip]="'Mobile Number'"
                                >(M)</span
                            > </span
                        ><br />
                        <span
                            class="hover-id"
                            *ngIf="element.landlineNumber !== ''"
                        >
                            <i class="ri-smartphone-line"></i>
                            {{ element.landlineNumber }}
                            <span [matTooltip]="'Official Number'"
                                >(O)</span
                            > </span
                        ><br />
                        <span
                            class="hover-id extension"
                            [matTooltip]="'Call Extension Number'"
                            *ngIf="element.extNumber !== '00' && element.extNumber !== '' && element.extNumber !== null"
                            (click)="extboundCall(element.extNumber)"
                        >
                            <i class="ri-phone-fill"></i>
                            {{ element.extNumber }}
                            <span [matTooltip]="'Extension Number'"
                                >(E)</span
                            > </span
                        ><br />
                        <div *ngIf="element?.aliasMail" class="mt-10">
                            <span class="alise_text">Alias Emails list :</span>
                            <span
                                *ngIf="getEmails(element?.aliasMail).length > 0"
                            >
                                <li
                                    *ngFor="
                                        let email of getEmails(
                                            element?.aliasMail
                                        )
                                    "
                                >
                                    {{ email }}
                                </li>
                            </span>
                        </div>
                        <span
                            [ngClass]="{
                                'text-danger':
                                    element?.external_email_access === 'yes',
                                'text-success':
                                    element?.external_email_access === 'no'
                            }"
                        >
                            Allow Externals Emails :
                            {{
                                element?.external_email_access === "yes"
                                    ? "Yes"
                                    : element?.external_email_access === "no"
                                    ? "No"
                                    : "N/A"
                            }}
                        </span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        <div *ngIf="dataSource.data.length === 0" class="no-data-message">
            No data found
        </div>
    </div>
</div>
